//@ts-nocheck
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

// Import reducers
import userReducer from './slices/userSlice';
import courseReducer from './slices/courseSlice';
import assessmentReducer from './slices/assessmentSlice';

// Combine all reducers
const rootReducer = combineReducers({
  user: userReducer,
  course: courseReducer,
  assessment: assessmentReducer,
});

// Configure store
const store = configureStore({
  reducer: rootReducer,
  // Redux Thunk is included by default in configureStore
});

// Export types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;